<div class="top-bar">
  <a href="javascript:;" class="toggle" (click)="onToggle($event)">
    <i class="pi pi-bars"></i>
  </a>
  <img src="assets/images/logo-technoserver.jpeg" alt="TechnoServer" class="top-logo" />
</div>
